import { FC, ReactElement, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AOS from "aos";

import "aos/dist/aos.css";

import Routes from "@/routes";
import { Splash } from "@/pages";
import { ScrollToTop, SnackbarMessage } from "@/components";

import { MessageContainer } from "@/context/message-context";
import { ModalProvider } from "@/context/modal-context";
import { HTSDescriptionsProvider } from "@/context/hts-descriptions-context";
import { useGetCompanyInfoQuery, useGetUserFromTokenQuery } from "@/services";
import { useAppSelector } from "@/store";
import { roles } from "@/roles";

const App: FC = (): ReactElement => {
  const { accessToken, isUserLoaded, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    AOS.init();
  }, []);

  const { isLoading } = useGetUserFromTokenQuery(undefined, {
    skip: !accessToken,
    refetchOnMountOrArgChange: true,
  });

  const isAdmin = user?.userRole === roles.TDADMIN;
  const { isLoading: companyLoading } = useGetCompanyInfoQuery(undefined, {
    // Wait until user is loaded; skip for TD Admin entirely (requires explicit tenant selection later)
    skip: !accessToken || !isUserLoaded || isAdmin,
  });
  if (isLoading || companyLoading || (accessToken && !isUserLoaded)) {
    return <Splash />;
  }

  return (
    <MessageContainer>
      <ModalProvider>
        <HTSDescriptionsProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes />
          </BrowserRouter>
          <SnackbarMessage />
        </HTSDescriptionsProvider>
      </ModalProvider>
    </MessageContainer>
  );
};

export default App;
